module.exports = __webpack_public_path__ + "static/media/Flamengo-2018.22455378.svg";